import React from 'react';
import ReactDOM from 'react-dom';
// import New from './new'
import 'bootstrap/dist/css/bootstrap.css';
import './index.css';
// import './files/header/header.css'
import Header from './files/header/header'
import reportWebVitals from './reportWebVitals';

ReactDOM.render(
  <Header/>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
